module.exports = __webpack_public_path__ + "static/g-medic-removebg-62aff41d4def9b3d16f8176f24eeb0b7.png";